export default "https://cdn-static.gokick.com/assets/6600ddf3ffcd3e3653ecf6807c0977bcbaa0931f/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";